import fire from "../../../assets/images/icons/fire.png";

export interface WhyChooseUsData {
  whyChooseUs: {
    icon: string;
    tag: string;
    title: string;
    tagline: string;
    description: string;
    button: {
      text: string;
      route: string;
    };
    images: {
      topRight: string;
      middleLeft: string;
      bottomRight: string;
    };
    featureTags: {
      topRight: string;
      bottomRight: string;
    };
  };
}

export const WhyChooseUsConstants: WhyChooseUsData = {
  whyChooseUs: {
    icon: fire,
    tag: "Why Choose Us",
    title: "What Makes CricCenter Different",
    tagline:
      "Built for modern cricket. Powered by smart technology. Trusted by players, teams, and leagues.",
    description:
      "CricCenter serves as the definitive digital backbone for modern cricket, offering a seamless transition from traditional paperwork to an elite, tech-driven ecosystem. It delivers a comprehensive match center featuring real-time ball-by-ball scoring, automated league management, and professional-grade statistics along with AI-driven analytics. ",
    button: {
      text: "View More",
      route: "/leagues-home",
    },
    images: {
      topRight: "/images/stadium-night.jpg",
      middleLeft: "/images/stadium-day.jpg",
      bottomRight: "/images/match-progress.jpg",
    },
    featureTags: {
      topRight: "All-in-One Cricket Management",
      bottomRight: "Built for Players, Teams & Organizers",
    },
  },
};
